import React from 'react'
import { AccordionContainer } from '../../../../../../../../common/components/accordion/accordion.module'
import { InputLabelContainer } from '../../../../../../../../common/components/form/label/containers/input-label.container'

export const GatewayCockpitInsightNPBasicInfoComponent = ({ selectedInsightsNPs }: any) => {
  return (
    <>
      <AccordionContainer
        child={
          <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <div>
              <div className='font-semibold text-sm'>
                <InputLabelContainer
                  label="Edge Id"
                />
              </div>
              <div className='text-xs'>
                <InputLabelContainer
                  label={selectedInsightsNPs?.EdgeId || '-'}
                />
              </div>
            </div>
            <div>
              <div className='font-semibold text-sm'>
                <InputLabelContainer
                  label="NP Id"
                />
              </div>
              <div className='text-xs'>
                <InputLabelContainer
                  label={selectedInsightsNPs?.NPId || '-'}
                />
              </div>
            </div>
            <div>
              <div className='font-semibold text-sm'>
                <InputLabelContainer
                  label="Name"
                />
              </div>
              <div className='text-xs'>
                <InputLabelContainer
                  label={selectedInsightsNPs?.Name || '-'}
                />
              </div>
            </div>
            <div>
              <div className='font-semibold text-sm'>
                <InputLabelContainer
                  label="Providers With Compliance"
                />
              </div>
              <div className='text-xs'>
                <InputLabelContainer
                  label={selectedInsightsNPs?.NoOfProvidersWithCompliance || '0'}
                />
              </div>
            </div>
            <div>
              <div className='font-semibold text-sm'>
                <InputLabelContainer
                  label="Providers Without Compliance"
                />
              </div>
              <div className='text-xs'>
                <InputLabelContainer
                  label={selectedInsightsNPs?.NoOfProvidersWithoutCompliance || '0'}
                />
              </div>
            </div>
            <div>
              <div className='font-semibold text-sm'>
                <InputLabelContainer
                  label="Providers Published To OpenNetwork"
                />
              </div>
              <div className='text-xs'>
                <InputLabelContainer
                  label={selectedInsightsNPs?.NoOfProvidersPublishedToOpenNetwork || '0'}
                />
              </div>
            </div>
            <div>
              <div className='font-semibold text-sm'>
                <InputLabelContainer
                  label="Providers Not Published To OpenNetwork"
                />
              </div>
              <div className='text-xs'>
                <InputLabelContainer
                  label={selectedInsightsNPs?.NoOfProvidersNotPublishedToOpenNetwork || '0'}
                />
              </div>
            </div>
            <div>
              <div className='font-semibold text-sm'>
                <InputLabelContainer
                  label="Providers Published To PartnerNetwork"
                />
              </div>
              <div className='text-xs'>
                <InputLabelContainer
                  label={selectedInsightsNPs?.NoOfProvidersPublishedToPartnerNetwork || '0'}
                />
              </div>
            </div>
            <div>
              <div className='font-semibold text-sm'>
                <InputLabelContainer
                  label="Providers Not Published To PartnerNetwork"
                />
              </div>
              <div className='text-xs'>
                <InputLabelContainer
                  label={selectedInsightsNPs?.NoOfProvidersNotPublishedToPartnerNetwork || '0'}
                />
              </div>
            </div>
            <div>
              <div className='font-semibold text-sm'>
                <InputLabelContainer
                  label="Total Providers"
                />
              </div>
              <div className='text-xs'>
                <InputLabelContainer
                  label={selectedInsightsNPs?.TotalNoOfProviders || '0'}
                />
              </div>
            </div>
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Details"
      />
    </>
  )
}
export default GatewayCockpitInsightNPBasicInfoComponent;